<template>
    <div id="ModalTwoFactoryEmail" class="modal fade in" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal content-->
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-envelope-o"></i> E-mail Authenticator</p>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{loginMsg}}</p>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group text-center">
                                <required /> <label>Token</label>
                                <v-otp-input :class="'justify-content-center'" ref="otpInput" input-classes="otp-input" separator="-" :num-inputs="5"
                                    :should-auto-focus="true" :is-input-num="true" @on-change="setToken"
                                    @on-complete="setToken" />
                                <div class="invalid-feedback help-block error">{{errors.first('company')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left">
                        <i class="fa fa-times"></i> {{$t('words.cancel')}}
                    </button>
                    <button type="button" @click="confirm()" :disabled="loading" class="btn btn-success"><i
                            class="fa fa-check"></i> {{$t('words.access')}}
                        <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            request: {}
        },
        data() {
            return {
                loginMsg: '',
                loading: false,
            }
        },
        methods: {
            setToken(payload) {
                this.request.token_otp = payload;
                if (this.request.token_otp.length === 5) {
                    this.confirm();
                }
            },
            show(response) {
                this.loginMsg = response.data.message;
                $('#ModalTwoFactoryEmail').modal('toggle');
            },
            confirm() {
                if (this.request.companyId) {
                    this.logar();
                } else {
                    this.login();
                }
            },
            logar() {
                this.loading = true;
                this.$auth.logar(this.request)
                    .then(response => {
                        console.log(response);
                        $('#ModalTwoFactoryEmail').modal('toggle');
                        window.location.href="/dashboard";
                    }).catch(error => {
                        toastr({
                            icon: error.data.status,
                            title: error.data.message
                        });
                    }).finally(() => {
                        this.loading = false;
                    });
            },
            login() {
                this.loading = true;
                this.$auth.login(this.request)
                    .then(response => {
                        console.log(response);
                        $('#ModalTwoFactoryEmail').modal('toggle');
                         window.location.href="/dashboard";
                    }).catch(error => {
                        toastr({
                            icon: error.data.status,
                            title: error.data.message
                        });
                    }).finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>
<style lang="css">
    .otp-input {
        width: 40px;
        height: 40px;
        padding: 5px;
        margin: 0 10px;
        font-size: 20px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        text-align: center;
    }

    .otp-input.error {
        border: 1px solid red !important;
    }

    .otp-input::-webkit-inner-spin-button,
    .otp-input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>